import React, { useRef, useState } from "react";
import styles from "../addCategoryForm/addCategoryForm.module.css";
import { Close, closeCircle, UploadImg } from "../../Svg";
import api from "../../utils/api";
import { toast } from "react-toastify";
import axios from "axios";

const MediaCard = ({ values, setFieldValue }) => {
    const imageRef = useRef(null);
    const videoRef = useRef(null);
    const [isUploading, setCoverUploading] = useState(false);
    const [loadings, setLoading] = useState(false);
    const [imageUrlInput, setImageUrlInput] = useState("");

   
    const handleImageChange = async (e, attribute,from) => {
        const files = e.target?.files || e.dataTransfer?.files;
        if (!files || files.length === 0) return;
        if(from == 'image'){
            setCoverUploading(true);
        }else{
            setLoading(true)
        }

        try {
            const existingFiles = values[attribute] || [];
            let uploadedFiles = [...existingFiles];

            for (const file of files) {
                const body = {
                    key: `${Date.now()}_${file.name}`,
                    fileType: file.type,
                    fileName: file.name,
                };

                const { data, status } = await api.getPutSignedUrl(body);
                if (status === 200) {
                    await axios.put(data.data?.preSigned, file, {
                        headers: { "Content-Type": file.type }
                    });

                    uploadedFiles = [...uploadedFiles, data?.data?.url];
                }
            }

            setFieldValue(attribute, uploadedFiles);
        } catch (err) {
            console.log(err);
            toast.error("Error uploading file");
        } finally {
            if(from == 'image'){
                setCoverUploading(false);
            }else{
                setLoading(false)
            }
        }
    };

    const handleAddImageUrl = () => {
        if (!imageUrlInput || !imageUrlInput.trim()) return;
        const url = imageUrlInput.trim();
        const existingImages = values?.assets?.image || [];
        setFieldValue("assets.image", [...existingImages, url]);
        setImageUrlInput("");
    };

    const handleRemove = (attribute, index) => {
        const parts = attribute.split('.');
        let currentArray = values;
        for (const p of parts) {
            currentArray = currentArray?.[p];
        }
        if (Array.isArray(currentArray)) {
            setFieldValue(attribute, currentArray.filter((_, i) => i !== index));
        }
    };

    return (
        <div>
            <div className={styles.formSection}>
                <div className={styles.card}>
                    <h2 className={styles.addCatH2}>Media</h2>

                    {/* Image Upload */}
                    <div className={styles.imageUpload} style={{ marginTop: "12px" }}>
                        <p className={styles.addCatLabel} style={{ marginBottom: "4px" }}>Photo</p>
                        {isUploading ? (
                            <div className={styles.uploadBox} style={{ padding: "12px" }}>Please wait...</div>
                        ) : (
                            <>
                                {values.assets?.image?.length <= 0 ? (
                                    <div className={styles.uploadBox} onClick={() => imageRef.current.click()} style={{ cursor: "pointer", padding: "14px 16px" }}>
                                        <span className={styles.uploadIcon} style={{ marginBottom: "4px" }}><UploadImg /></span>
                                        <p className={styles.addCatPara} style={{ fontSize: "13px", marginBottom: "8px" }}>Drag and drop images here, or click to add</p>
                                        <input
                                            type="file"
                                            style={{ display: "none" }}
                                            ref={imageRef}
                                            onChange={(e) => handleImageChange(e, "assets.image", "image")}
                                            accept="image/*"
                                            multiple
                                        />
                                        <button type="button" className={styles.addImgBtn} style={{ padding: "6px 14px", fontSize: "13px" }}>Add Images</button>
                                    </div>
                                ) : (
                                    <div className={styles.imagePreviewContainer}>
                                        <div className={styles.uploadBox} style={{ display: 'flex', flexWrap: 'wrap', gap: '10px', alignItems: 'center', padding: "12px" }}>
                                            {values.assets.image.map((img, index) => (
                                                <div key={index} className={styles.previewContainer} style={{ display: 'flex' }}>
                                                    <img src={img} alt="" className={styles.previewImage} />
                                                    <div className={styles.cancel_cross} onClick={() => handleRemove("assets.image", index)}>
                                                        {closeCircle()}
                                                    </div>
                                                </div>
                                            ))}
                                            <div 
                                                onClick={() => imageRef.current.click()} 
                                                style={{ cursor: "pointer", border: "1px dashed #ced4da", borderRadius: "8px", padding: "8px", display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", minWidth: "80px", minHeight: "80px" }}
                                            >
                                                <span className={styles.uploadIcon} style={{ fontSize: "1rem", marginBottom: "2px" }}><UploadImg /></span>
                                                <span style={{ fontSize: "11px", color: "#512DA8", fontWeight: 600 }}>+ Add More</span>
                                            </div>
                                        </div>
                                        <input
                                            type="file"
                                            style={{ display: "none" }}
                                            ref={imageRef}
                                            onChange={(e) => handleImageChange(e, "assets.image", "image")}
                                            accept="image/*"
                                            multiple
                                        />
                                    </div>
                                )}

                                <div className={styles.urlInputContainer} style={{ marginTop: "8px" }}>
                                    <input
                                        type="text"
                                        placeholder="Enter image URL"
                                        className={styles.urlInput}
                                        value={imageUrlInput}
                                        onChange={(e) => setImageUrlInput(e.target.value)}
                                        onKeyDown={(e) => {
                                            if (e.key === "Enter") {
                                                e.preventDefault();
                                                handleAddImageUrl();
                                            }
                                        }}
                                    />
                                    <button type="button" className={styles.urlAddBtn} onClick={handleAddImageUrl}>
                                        Add URL
                                    </button>
                                </div>
                            </>
                        )}
                    </div>

                    {/* Video Upload */}
                    <div className={styles.imageUpload} style={{ marginTop: "12px" }}>
                        <p className={styles.addCatLabel} style={{ marginBottom: "4px" }}>Video</p>
                        {loadings ? (
                            <div className={styles.uploadBox} style={{ padding: "12px" }}>Please wait...</div>
                        ) : (
                            <>
                                {values.assets?.video?.length <= 0 ?
                                        <div className={styles.uploadBox} onClick={() => videoRef.current.click()} style={{ cursor: "pointer", padding: "14px 16px" }}>
                                            <span className={styles.uploadIcon} style={{ marginBottom: "4px" }}><UploadImg /></span>
                                            <p className={styles.addCatPara} style={{ fontSize: "13px", marginBottom: "8px" }}>Drag and drop videos here, or click to add</p>
                                            <input
                                                type="file"
                                                style={{ display: "none" }}
                                                ref={videoRef}
                                                onChange={(e) => handleImageChange(e, "assets.video", "video")}
                                                accept="video/*"
                                            />
                                            <button type="button" className={styles.addImgBtn} style={{ padding: "6px 14px", fontSize: "13px" }}>Add Video</button>
                                        </div>
                                        :

                                        <div className={styles.imagePreviewContainer}>
                                            {values.assets.video.length > 0 && (
                                                <div className={styles.uploadBox} style={{ display: 'flex', flexWrap: 'wrap', gap: '10px' }}>
                                                    {values.assets?.video?.map((video, index) => (
                                                        <div key={index} className={styles.previewContainer} style={{display:'flex',}}>
                                                            <video src={video} className={styles.previewVideo} controls style={{width:'100%'}}/>
                                                            <div className={styles.cancel_cross} onClick={() => handleRemove("assets.video", index)}>
                                                                {closeCircle()}
                                                            </div>
                                                        </div>
                                                    ))}
                                                </div>
                                            )}

                                        </div>

                                }
                            </>
                        )}
                    </div>
                </div>
            </div>
        </div >
    );
};

export default MediaCard;
